export const environment = {
  production: false,
  srecApiUrl: 'https://apim-sprucepowermarketingdesk-prd.azure-api.net',
  srecApiKey: '4faf67b2b8ed42e298fb3bbe9786d292'
};